import ApiAcces from "@/shared/services/ApiAcces";
import type IWorkspaceService from "../contracts/IWorkspaceService";
import type {
  WorkspaceDetail,
  WorkspaceSummary,
  WorkspaceUpsert,
} from "../models/Workspace";

export default class WorkspaceService
  extends ApiAcces
  implements IWorkspaceService
{
  async getAll(): Promise<WorkspaceSummary[]> {
    return (await this.api.get("api/workspaces")).data;
  }

  async get(workspaceId: string): Promise<WorkspaceDetail> {
    return (await this.api.get(`api/workspaces/${workspaceId}`)).data;
  }

  async create(workspace: WorkspaceUpsert): Promise<WorkspaceSummary> {
    return (await this.api.post("api/workspaces", workspace)).data;
  }

  async update(
    workspaceId: string,
    workspace: WorkspaceUpsert,
  ): Promise<WorkspaceSummary> {
    return (await this.api.put(`api/workspaces/${workspaceId}`, workspace)).data;
  }

  async delete(workspaceId: string): Promise<void> {
    await this.api.delete(`api/workspaces/${workspaceId}`);
  }

  async assignWorkflow(workspaceId: string, workflowId: string): Promise<void> {
    await this.api.post(`api/workspaces/${workspaceId}/workflows`, { workflowId });
  }

  async removeWorkflow(workspaceId: string, workflowId: string): Promise<void> {
    await this.api.delete(`api/workspaces/${workspaceId}/workflows/${workflowId}`);
  }
}
